import React, { Component } from 'react';
import { Table, Button, } from 'semantic-ui-react';
import { serverIp, toCurrency, pythonApiIp, } from '../../../../config/constants.js'
import axios from 'axios'
import * as UiConsts from '../../../../config/UiConstants';

class ViewRecentVinylPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unpaidList: [],
        }
    }

    componentDidMount() {
        console.log("++++++++:componentDidMount");
        this.getUnpaidList();
    }

    getUnpaidList = () => {
        console.log("++++++++:getUnpaidList");
       // console.log("new state item array:" + JSON.stringify(this.state.itemArray));
       // console.log("date:" + this.state.dateNum);

        this.setState({ loading: true, });

        axios.post(serverIp + 'stockPayment/getRecentVinylPayments', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: "testemail",
            numRecords: 100
        })
            .then((response) => {
                console.log("dud1:"+JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        unpaidList: response.data.unpaidList,
            
                    });


                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }


    render() {


        const rows = this.state.unpaidList.length > 0
            ? this.state.unpaidList.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.daDate} </Table.Cell>
                    <Table.Cell> {item.iditemsBoughtDetail} </Table.Cell>
                    <Table.Cell>{item.item}</Table.Cell>
                    <Table.Cell>{item.qty}</Table.Cell>
                    <Table.Cell>{toCurrency(item.price)}</Table.Cell>
                    <Table.Cell>{toCurrency(item.qty * item.price)}</Table.Cell>

                    {/* <Table.Cell><Button color='red'>PAY</Button></Table.Cell> */}
                </Table.Row>)
            : ''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h4> RECENT VINYL PAYMENT ENTRIES </h4>
           
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>Qty</Table.HeaderCell>
                        <Table.HeaderCell>Price</Table.HeaderCell>
                        <Table.HeaderCell>Total</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>
          
        </div>);
    }
}

export default ViewRecentVinylPayments;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/ViewVinylPayment.js